
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import Patient from '@/types/Patient';
    import {CompareFunction, DataTableHeaders} from '@/types';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders']),
            ...mapState('patient', ['patienten']),
        },
        methods: {
            ...mapActions('statistik', ['printOffeneSalden']),
            ...mapActions('patient', ['loadPatienten']),
        },
    })
    export default class OffeneSalden extends Vue {
        @Prop() public visible!: boolean;

        public printOffeneSalden!: (payload: Patient[]) => void;
        public patient = new Patient();
        public patienten:any;
        public loadPatienten!: () => void;
        public sortDate!: CompareFunction<Patient>;

        public get headers(): DataTableHeaders<Patient> {
            return [
                { text: 'Nachname', value: 'nachname' },
                { text: 'Vorname', value: 'nachname' },
                { text: 'Geburtsdatum', value: 'geburtsdatum', sort: this.sortDate},
                { text: 'SVNr', value: 'svnr' },
                { text: 'Restbetrag', value: 'restbetrag' },
                { text: 'Telefon', value: 'telefon' },
            ];
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadPatienten();
            }
        }

        public onClickPrint(patienten: Patient[]): void {
            this.printOffeneSalden(patienten);
        }

        public handleClick(item: Patient) {
            console.log(item);
        }
    }
